module.exports = __webpack_public_path__ + "static/media/franco-team-img-370x370.d4341f52.jpg";